import React from 'react'

import './styles.scss'

import { IntroProps } from '../types'

import backgroundImg from './img/background.jpg'
import brush_mobile from './img/brush-mobile.png'
import plus_mobile from './img/plus-mobile.png'
import brush_desktop from './img/brush-desktop.png'
import plus_desktop from './img/plus-desktop.png'

import { CheckImagesLoaded } from '../utils/CheckImagesLoaded'

const Intro = ({
  coupleData: { coupleSimplifiedName, coupleSingleName, weddingDate },
  buttonMessage,
  warningMessage,
  background,
  delay = 0,
  onSkipIntro,
  onLoad,
}: IntroProps) => {
  const text =
    new Date() > new Date(weddingDate.timestamp)
      ? 'JÁ SE CASARAM!'
      : 'VÃO SE CASAR!'
  return (
    <CheckImagesLoaded delay={delay} onLoad={onLoad} className="intro269">
      <div className="intro269mobile screen">
        <img
          className="main-background-5mcmBB"
          src={background || backgroundImg}
        />
        <div className="mask-5mcmBB"></div>
        <div className="container-center-horizontal">
          <div className="button-5mcmBB">
            <p
              className="site-de-casamento-e-rLl78g"
              dangerouslySetInnerHTML={{ __html: warningMessage }}
            />
            <button className="button-rLl78g" onClick={onSkipIntro}>
              {buttonMessage}
            </button>
          </div>
        </div>
        <div className="container-center-vertical container-center-horizontal">
          <div className="couple-name-and-date-5mcmBB">
            <div className="name-n0JaK2">
              <img
                className="brush-U9oMNs bp1-intro269-animate-enter1"
                src={brush_mobile}
              />
              <div className="notranslate d-U9oMNs bp1-intro269-animate-enter2">
                {coupleSimplifiedName.groom}
              </div>
              <img
                style={coupleSimplifiedName.groom ? {} : { display: 'none' }}
                className="x-U9oMNs bp1-intro269-animate-enter3"
                src={plus_mobile}
              />
              <div
                className="notranslate m-U9oMNs bp1-intro269-animate-enter4"
                style={
                  coupleSimplifiedName.groom
                    ? {}
                    : { left: 0, width: '100%', textAlign: 'center' }
                }
              >
                {coupleSimplifiedName.bride}
              </div>
            </div>
            <div className="date-n0JaK2 bp1-intro269-animate-enter">{text}</div>
          </div>
        </div>
      </div>
      <div className="intro269desktop screen">
        <img
          className="main-background-6wNzS7"
          src={background || backgroundImg}
        />
        <div className="mask-6wNzS7"></div>
        <div className="container-center-horizontal">
          <div className="button-6wNzS7">
            <p
              className="site-de-casamento-e-K6fFxJ"
              dangerouslySetInnerHTML={{ __html: warningMessage }}
            />
            <button className="button-K6fFxJ" onClick={onSkipIntro}>
              {buttonMessage}
            </button>
          </div>
        </div>
        <div className="container-center-vertical container-center-horizontal">
          <div className="couple-name-and-date-6wNzS7">
            <div className="name-fgOnS7">
              <img
                className="brush-L9yZXb bp2-intro269-animate-enter1"
                src={brush_desktop}
              />
              <h1 className="notranslate title-L9yZXb bp2-intro269-animate-enter2">
                {coupleSingleName.groom}
              </h1>
              <img
                style={coupleSingleName.groom ? {} : { display: 'none' }}
                className="x-L9yZXb bp2-intro269-animate-enter3"
                src={plus_desktop}
              />
              <div
                className="notranslate mari-L9yZXb bp2-intro269-animate-enter4"
                style={
                  coupleSingleName.groom
                    ? {}
                    : { left: 0, width: '100%', textAlign: 'center' }
                }
              >
                {coupleSingleName.bride}
              </div>
            </div>
            <div className="date-fgOnS7 bp2-intro269-animate-enter">{text}</div>
          </div>
        </div>
      </div>
    </CheckImagesLoaded>
  )
}

export default Intro
